// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-section {
  margin-top: 2em;
  color: #ffffff;
}

.text-container {
  text-align: left; /* Align text to the left */
  background-color: rgba(0, 0, 0, 0); /* Optional: add a dark overlay */
  border-radius: 8px; /* Optional: round the corners */
}

.contact_title {
  font-size: 4rem;
  color: #ffffff;
  border-bottom: 1px solid #FFE600;
  display: inline-block; /* Make the title's border wrap around the text */
  padding-bottom: 10px; /* Optional: Add some space between the text and the border */
}

.subtext {
  color: #aab5b7;
  line-height: 1.5em;
}

.location_highlight {
  color: #FFE600;
  border-bottom: 1px solid #FFE600;
}

/* Additional responsive adjustments if necessary */
@media (max-width: 768px) {
  .contact_title {
    font-size: 3rem; /* Adjust title size on smaller screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/HOME/SECTIONS/CONTACT/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB,EAAE,2BAA2B;EAC7C,kCAAkC,EAAE,iCAAiC;EACrE,kBAAkB,EAAE,gCAAgC;AACtD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,qBAAqB,EAAE,iDAAiD;EACxE,oBAAoB,EAAE,6DAA6D;AACrF;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA,mDAAmD;AACnD;EACE;IACE,eAAe,EAAE,yCAAyC;EAC5D;AACF","sourcesContent":[".contact-section {\n  margin-top: 2em;\n  color: #ffffff;\n}\n\n.text-container {\n  text-align: left; /* Align text to the left */\n  background-color: rgba(0, 0, 0, 0); /* Optional: add a dark overlay */\n  border-radius: 8px; /* Optional: round the corners */\n}\n\n.contact_title {\n  font-size: 4rem;\n  color: #ffffff;\n  border-bottom: 1px solid #FFE600;\n  display: inline-block; /* Make the title's border wrap around the text */\n  padding-bottom: 10px; /* Optional: Add some space between the text and the border */\n}\n\n.subtext {\n  color: #aab5b7;\n  line-height: 1.5em;\n}\n\n.location_highlight {\n  color: #FFE600;\n  border-bottom: 1px solid #FFE600;\n}\n\n/* Additional responsive adjustments if necessary */\n@media (max-width: 768px) {\n  .contact_title {\n    font-size: 3rem; /* Adjust title size on smaller screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
